import { createFileRoute } from '@tanstack/react-router';
import { ConfigForm } from '~/components/form/config-form';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <main style={{ padding: '2rem 1rem', minHeight: '100vh' }}>
      <ConfigForm />
    </main>
  );
}
